import React, { useState } from "react";
import css from "./Header.module.css";
import Logo from "../assets/logo.png";
import { IoCartSharp } from "react-icons/io5";
import { TiThMenu } from "react-icons/ti";


const Header = () => {
    const [showMenu , setShowmenu]  = useState(true)
    const toggleMenu =()=>{
        setShowmenu((showMenu)=>!showMenu)
    }
  return (
    <div className={css.container}>
      <div className={css.logo}>
        <img src={Logo} alt="" />
        <span>Amazon</span>
      </div>
      <div className={css.right}>
        <div className="bars" onClick={toggleMenu}>
        <TiThMenu  className="bars"/>
        </div>
    
          <ul className={css.menu} style={{display: showMenu? 'inherit':"none"}}>
            <li>Collections</li>
            <li>Brands</li>
            <li>New</li>
            <li>Sales</li>
            <li>Eng</li>
          </ul>
    
        <input type="text" className={css.search} placeholder="Search" />
        <IoCartSharp className={css.cart} />
      </div>
    </div>
  );
};

export default Header;
